import { render } from "./MenuTableBackgroundFile.vue?vue&type=template&id=da5b1330&scoped=true"
import script from "./MenuTableBackgroundFile.vue?vue&type=script&lang=js"
export * from "./MenuTableBackgroundFile.vue?vue&type=script&lang=js"

import "./MenuTableBackgroundFile.vue?vue&type=style&index=0&id=da5b1330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da5b1330"]])

export default __exports__